import React from 'react';
import PropTypes from 'prop-types';
import {
  GoPaperlessPolicyPreferenceContainer,
  PolicyEmailAddress,
  PolicyLabelMobile,
  PolicyMailingAddress,
  PolicyNumberLabel,
  PolicySummary,
  PreferenceLabelMobile,
  PreferenceRadioEmail,
  PreferenceRadioMail,
  ProfileEditorsContainer,
  ProfileRadioButtonContainer,
} from './styles';
import { getText } from '../../../utils/i18n';
import { getPolicyEmail, getPolicyMailingAddress } from './selectors';

export const NonStatementAccountPoliciesDeliveryPreferences = (props) => {
  const {
    editingDeliveryPreferences,
    filteredUnderlyingAccounts,
    i18n,
    isLoading,
    mappedPolicyPreference,
    setMappedPolicyPreference,
  } = props;

  const goPaperlessMissingEmailHelperText = getText(
    i18n,
    'policyDetails.helper.missingEmailText',
    'No email address found. Please add an email address to your policy if you wish to select paperless.',
  );
  const updatePreferences = (index, option) => {
    let newMap = mappedPolicyPreference.map((policy, i) => {
      if (i === index) {
        policy.newPreference = option;
        return policy;
      } else {
        return policy;
      }
    });
    setMappedPolicyPreference(newMap);
  };

  return (
    <>
      {mappedPolicyPreference.map((policy, index) => {
        return (
          !filteredUnderlyingAccounts.some((account) =>
            account.some((subAccount) => subAccount.arPolicy.policyRef === policy.policyRef),
          ) && (
            <GoPaperlessPolicyPreferenceContainer key={policy.policyRef} $index={index}>
              <PolicySummary>
                <PolicyLabelMobile>
                  Policy {policy.policyNumber + ' (' + policy.statusCd + ')'}
                </PolicyLabelMobile>
                <PolicyNumberLabel
                  aria-label={`Policy Number ${policy.policyNumber} Status ${policy.statusCd}`}
                >
                  {policy.policyNumber + ' (' + policy.statusCd + ')'}
                </PolicyNumberLabel>
                <PolicyEmailAddress>
                  Email:{' '}
                  {getPolicyEmail(policy)
                    ? getPolicyEmail(policy)
                    : goPaperlessMissingEmailHelperText}
                </PolicyEmailAddress>
                <PolicyMailingAddress>
                  Address: {getPolicyMailingAddress(policy)}
                </PolicyMailingAddress>
              </PolicySummary>
              <ProfileEditorsContainer>
                <PreferenceLabelMobile>Preference</PreferenceLabelMobile>
                <ProfileRadioButtonContainer>
                  <PreferenceRadioEmail>
                    <label htmlFor={`radioEmailPolicies${index}`}>
                      <input
                        aria-label={`Preference for ${policy.policyNumber} Paperless`}
                        type="radio"
                        name={'deliveryPref_policy_' + index}
                        value="Email"
                        id={`radioEmailPolicies${index}`}
                        onChange={() => updatePreferences(index, 'Email')}
                        checked={
                          policy.newPreference === null
                            ? policy.insured.preferredDeliveryMethod === 'Email'
                            : policy.newPreference === 'Email'
                        }
                        disabled={
                          isLoading || !editingDeliveryPreferences || !getPolicyEmail(policy)
                        }
                      />{' '}
                      Paperless
                    </label>
                  </PreferenceRadioEmail>
                  <PreferenceRadioMail>
                    <label htmlFor={`radioBatchPolicies${index}`}>
                      <input
                        aria-label={`Preference for ${policy.policyNumber} Mail`}
                        type="radio"
                        name={'deliveryPref_policy_' + index}
                        value="Batch"
                        id={`radioBatchPolicies${index}`}
                        onChange={() => updatePreferences(index, 'Batch')}
                        checked={
                          policy.newPreference === null
                            ? policy.insured.preferredDeliveryMethod === 'Batch'
                            : policy.newPreference === 'Batch'
                        }
                        disabled={isLoading || !editingDeliveryPreferences}
                      />{' '}
                      Mail
                    </label>
                  </PreferenceRadioMail>
                </ProfileRadioButtonContainer>
              </ProfileEditorsContainer>
            </GoPaperlessPolicyPreferenceContainer>
          )
        );
      })}
    </>
  );
};

NonStatementAccountPoliciesDeliveryPreferences.propTypes = {
  i18n: PropTypes.object,
  isLoading: PropTypes.bool,
  editingDeliveryPreferences: PropTypes.bool,
  filteredUnderlyingAccounts: PropTypes.array,
  mappedPolicyPreference: PropTypes.array,
  setMappedPolicyPreference: PropTypes.func,
};

export default NonStatementAccountPoliciesDeliveryPreferences;
